import { OnlineContractingStateEnum } from 'v3/data/store/onlineContracting/enums';
import { getChannelLabel, OnlineContractingStateMapping } from 'v3/data/store/onlineContracting/mapping';
import { theme } from 'v3/styles/global-styles';

export { getChannelLabel };

const UNKNOWN_STATUS_LABEL = 'Status desconhecido';

const FINISHED_STATES = [OnlineContractingStateEnum.ContractingFinished];
const REJECTED_STATES = [
  OnlineContractingStateEnum.CreditAnalysisRejected,
  OnlineContractingStateEnum.ContractingDenied,
  OnlineContractingStateEnum.CpfBlocked,
  OnlineContractingStateEnum.CafRejected,
  OnlineContractingStateEnum.ContractingCanceled,
];

export const getFinancingStatusDetails = (status: OnlineContractingStateEnum): { label: string; color: string } => {
  const label = OnlineContractingStateMapping[status]?.title || UNKNOWN_STATUS_LABEL;

  if (FINISHED_STATES.includes(status)) {
    return { label, color: theme.palette.green.main };
  }
  if (REJECTED_STATES.includes(status)) {
    return { label, color: theme.palette.tertiary.main };
  }
  if (!status || status === OnlineContractingStateEnum.ExpiredKey) {
    return { label, color: theme.palette.secondary.light };
  }
  return { label, color: theme.palette.warning.main };
};
